import React from 'react';
import ConfirmationIcon from '@atlaskit/icon/glyph/check-circle';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import InfoIcon from '@atlaskit/icon/glyph/info';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { colors } from '@atlaskit/theme';

export type IconType = 'connectivity' | 'error' | 'info' | 'success' | 'warning';

type IconSize = 'small' | 'medium' | 'large' | 'xlarge';

interface Props {
  type: IconType;
  size?: IconSize;
  isHovered?: boolean;
  // to pass any color code directly
  color?: keyof typeof colors;
}

const baseIconColors = {
  connectivity: colors.B300,
  error: colors.R400,
  info: colors.P300,
  success: colors.G300,
  warning: colors.Y300,
};

const hoverIconColors = {
  connectivity: colors.B200,
  error: colors.R300,
  info: colors.P200,
  success: colors.G200,
  warning: colors.Y200,
};

const iconByType = {
  connectivity: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
  success: ConfirmationIcon,
  warning: WarningIcon,
};

const Icon = ({ type, size = 'medium', isHovered = false, color: _color }: Props) => {
  const Icon = iconByType[type];
  const color = isHovered ? hoverIconColors[type] : baseIconColors[type];
  return <Icon primaryColor={(_color && (colors[_color] as string)) || color} size={size} label={`${type} icon`} />;
};

export default Icon;
